import { inject, Injectable } from '@angular/core';

import { AuthStore } from './auth-store';

import { type PermissionKey } from '@entities/profile';

@Injectable({ providedIn: 'root' })
export class PermissionService {
  private readonly store = inject(AuthStore);

  has(permission: PermissionKey): boolean {
    return this.store.profile()?.permissions[permission] ?? false;
  }

  hasAll(permissions: PermissionKey[]): boolean {
    return permissions.every((p) => this.has(p));
  }

  hasAny(permissions: PermissionKey[]): boolean {
    return permissions.some((p) => this.has(p));
  }
}
